module.exports = __webpack_public_path__ + "img/razzo.2e1e5845.jpg";